import { useQuery } from '@tanstack/react-query';
import { getMe, CurrentUser, GetMeOutput } from '@uplift/api';

export const meToCurrentUser = (data: GetMeOutput['data']): CurrentUser => {
  return {
    id: data.user.id,
    role: data.user.role,
    adminRole: data.user.adminRole ?? undefined,
    firstName: data.user.firstName,
    middleName: data.user.middleName,
    lastName: data.user.lastName,
    status: data.user.status,
    email: data.user.email,
    timezone: data.profile?.timezone,
    medicalRole: data.user.medicalRole ?? undefined,
    preferredName: data.profile?.preferredName,
    avatarSrc: data.avatarAsset?.url,
    fullTime: data.providerDetails?.fullTime,
    rules: data.rules,
    isImpersonated: data.isImpersonated,
    isCollaborativePhysician: data.providerDetails?.collaborativePhysician,
    isLoading: false,
    subsystem: data.user.subsystem,
    permissions: new Set(data.permissions ?? []),
  };
};


export const useCurrentUser = (pause: boolean, accessToken?: string) => {
  const enabled = !pause && !!accessToken;

  const { data, isInitialLoading: isLoading } = useQuery({
    queryKey: [ 'me', accessToken ],
    queryFn: async () => await getMe(),
    enabled: enabled,
    keepPreviousData: true,
  });

  return {
    data: data?.data,
    isLoading,
  };
};
